export const fonts = {
  ET3LightFont: "Montserrat-Light",
  Et3MediumFont: "Montserrat-Medium",
  Et3BoldFont: "Montserrat-Bold"
};

export default fonts;
